import { render } from "./Arquivos.vue?vue&type=template&id=3e8b91c9"
import script from "./Arquivos.vue?vue&type=script&lang=js"
export * from "./Arquivos.vue?vue&type=script&lang=js"

import "./Arquivos.vue?vue&type=style&index=0&id=3e8b91c9&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__